import { useQuery } from '@tanstack/react-query'
import type { OrpcClient } from '@/orpc/client'
import { useOrpc } from './useClient'

export type PractitionerOpsOrganization = Awaited<
  ReturnType<OrpcClient['getMyPractitionerOpsScope']>
>['organizations'][number]

const NO_ORGANIZATIONS: PractitionerOpsOrganization[] = []

/**
 * The Organizations the caller may run Provider Operations for, ordered by name — the
 * middleware's answer (`GET /v2/practitioners/me/scope`), not a role lookup here. Empty for
 * a physician or a Call Center Manager, and also while loading or after a failed read,
 * so every consumer fails closed: no nav entry, `/providers` redirects home.
 *
 * Shared by the nav, the route guard and the page through react-query's cache, so one
 * request serves all three.
 */
export function usePractitionerOpsScope({ enabled = true }: { enabled?: boolean } = {}) {
  const orpc = useOrpc()
  const query = useQuery(
    orpc.getMyPractitionerOpsScope.queryOptions({ enabled, staleTime: 5 * 60 * 1000 }),
  )
  return {
    organizations: query.data?.organizations ?? NO_ORGANIZATIONS,
    isLoading: query.isLoading,
  }
}
